<template>
  <v-layout wrap>
    <template v-if="rhtValue.loading" class="mt-5">
      <full-screen-spinner
        spinner-text="Loading planner data..."
        top-margin="0px"
      />
    </template>
    <v-flex v-else xs12 xl8>
      <div class="planner-container__tab-header px-2">
        <planner-tab-navigation
          :active.sync="active"
          :disable-tabs="disableTabs"
          :items="tabHeaders"
          @tab-changed="setSelectedTab($event)"
        />
      </div>
      <div class="planner-container__tab-content mx-2">
        <filter-container
          v-if="selectedTab === 0"
          :filters="filters"
          @filter-clicked="filterClicked($event)"
        />
        <requested-home-tours
          v-show="selectedTab === 0"
          :selected-client-homes="clientHomesWithPropertiesFiltered"
          @disable-tabs="disableTabs = $event"
        />
        <client-route-details
          v-show="selectedTab === 1"
          :have-routes="!!sortedClientRoutes.length"
          :client-routes="sortedClientRoutes"
          @go-to-requested-homes="goToRequestedHomes"
        />
        <client-feedback-info
          v-show="selectedTab === 2"
          :table-data="viewedHomes"
          :feedback-type="feedbackDataType[2]"
        />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import { feedbackDataType } from '../../../utils/generalConsts'
import PlannerTabNavigation from './PlannerTabNavigation.vue'
import ClientRouteDetails from './ClientRouteDetails.vue'
import RequestedHomeTours from './RequestedHomeTours.vue'
import ClientFeedbackInfo from '../../agent/feedback/ClientFeedbackInfo.vue'
import FullScreenSpinner from '../../../components/uiUtils/FullScreenSpinner'
import FilterContainer from '../../client/favorites/FilterContainer.vue'
import {
  isDeclinedRoute,
  isNotScheduledType,
  isPastRoute
} from '../../../utils/routeUtils'
import { sortObjectArrayByKey, isEmpty } from '../../../utils/generalUtils'

export default {
  components: {
    PlannerTabNavigation,
    ClientRouteDetails,
    RequestedHomeTours,
    ClientFeedbackInfo,
    FilterContainer,
    FullScreenSpinner
  },

  props: {
    viewedHomes: {
      type: Object,
      required: true
    },
    haveRoutes: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      active: 0,
      tabHeaders: [
        { value: 0, icon: 'favorite', title: 'Requested Home Tours' },
        { value: 1, icon: 'map', title: 'Routes' },
        { value: 2, icon: 'home', title: 'Viewed Homes' }
      ],
      feedbackDataType,
      disableTabs: true,
      filters: [
        { name: 'all', value: 'all', divider: '|' },
        { name: 'for sale', value: 'Residential', divider: '|' },
        { name: 'for rent', value: 'ResidentialLease' }
      ],
      selectedFilter: 'all',
      sortedClientRoutes: []
    }
  },

  computed: {
    ...mapState('agent', ['selectedTab', 'rhtValue', 'agentRouteData']),
    ...mapState('client', ['clientData']),

    clientHomesWithPropertiesFiltered() {
      if (this.rhtValue.loading) {
        return []
      }
      if (this.selectedFilter === 'all') {
        return this.rhtValue.data
      }
      return this.rhtValue.data.filter(
        item => item.PropertyType === this.selectedFilter
      )
    }
  },

  watch: {
    active() {
      this.setSelectedTab(this.active)
    },

    agentRouteData: {
      handler: function(value) {
        this.createSortedClientRoutes(value)
      },
      deep: true
    },

    clientData() {
      this.createSortedClientRoutes(this.agentRouteData)
    }
  },

  created() {
    this.active = this.selectedTab
  },

  mounted() {
    this.createSortedClientRoutes(this.agentRouteData)
  },

  methods: {
    ...mapActions('agent', ['setSelectedTab']),
    ...mapMutations('agent', {
      setFavorableViewTime: 'SET_FAVORABLE_VIEW_TIME'
    }),

    createSortedClientRoutes(routeList) {
      let clientRoutes = routeList.filter(
        route => route.clientId === this.clientData._id
      )

      if (!isEmpty(clientRoutes)) {
        this.setFavorableViewTime(clientRoutes[0].viewingTimeMins || 20)
        clientRoutes = _.groupBy(clientRoutes, route => {
          return (
            !isDeclinedRoute(route) &&
            !isNotScheduledType(route) &&
            !isPastRoute(route)
          )
        })
        const activeRoutes = sortObjectArrayByKey(
          clientRoutes['true'],
          'startTime'
        )
        if (!isEmpty(activeRoutes) && !isEmpty(clientRoutes['false'])) {
          this.sortedClientRoutes = [...activeRoutes, ...clientRoutes['false']]
        } else if (isEmpty(activeRoutes)) {
          this.sortedClientRoutes = clientRoutes['false'] || []
        } else {
          this.sortedClientRoutes = activeRoutes
        }
      } else {
        this.setFavorableViewTime(20)
      }
    },

    goToRequestedHomes() {
      this.setSelectedTab(0)
      this.active = 0
    },

    filterClicked(val) {
      this.selectedFilter = val
    }
  }
}
</script>

<style lang="sass" scoped>
.planner-container__tab-content
  border-radius: 0 0 1rem 1rem
  background: $hwayzWhite
  padding: 3rem
  min-height: 40vh
  -webkit-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  -moz-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
.link_container
  margin: 1rem 0 2rem !important
</style>
